class SiteHeader {
    constructor($el, stickyOffset) {
        this.$el = $el;

        this.isSticky = false;
        this.isTicking = false;
        this.stickyOffset = stickyOffset;
        this.lastScrollPosition = window.pageYOffset;
        this.updateFn = this._update.bind(this);
        this.infoBanner = document.getElementById('banner');
		this.infoBannerHeight = 0;

        if(this.infoBanner) {
			this.infoBannerHeight = this.infoBanner.offsetHeight;
		}

		this.translate = this.infoBannerHeight;

        if(this.$el.length) {
            this._onScroll();
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onScrollFn = this._onScroll.bind(this);
        this.onResizeFn = this._onResize.bind(this);

        window.addEventListener('scroll', this.onScrollFn);
        window.addEventListener('resize', this.onResizeFn);
        window.addEventListener('load', this.onResizeFn);
    }

    _onScroll() {
        this.lastScrollPosition = window.pageYOffset;

        if(!this.isTicking) {
            this.isTicking = true;

            window.requestAnimationFrame(this.updateFn);
        }
    }
    
    _onResize() {
        if(this.infoBanner) {
            this.infoBannerHeight = this.infoBanner.offsetHeight;
            this.translate = this.infoBannerHeight;
            this.isSticky = false;

            this.$el[0].classList.remove('site-header--sticky');
            this.$el[0].style.transform = 'translateY(0)';
            this.infoBanner.style.transform = 'translateY(0)';
            
            this._onScroll();
        }
    }

    _update() {
        this.isTicking = false;

        const previousState = this.isSticky;

        if(!this.isSticky && this.lastScrollPosition >= this.stickyOffset) {
            this.$el[0].classList.add('site-header--sticky');
            this.isSticky = true;
            this.$el[0].style.transform = 'translateY(-' + this.translate + 'px)';
            this.infoBanner.style.transform = 'translateY(-' + this.translate + 'px)';
        }
        else if(this.isSticky && this.lastScrollPosition < this.stickyOffset) {
            this.$el[0].classList.remove('site-header--sticky');
            this.isSticky = false;
            this.$el[0].style.transform = 'translateY(0px)';
            this.infoBanner.style.transform = 'translateY(0px)';
        }

        if(previousState !== this.isSticky) {
            $(window).trigger('header:stateChange');
        }
    }
}

export default SiteHeader;
